import { apiService, createUserAgentString } from "@blacknut/javascript-sdk/dist";
import { State } from "core/redux";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import getEnv from "./getEnv";
import { logD } from "@blacknut/logging/dist";
import { LOGGING_TAG } from "./Utils";
import { useMemo } from "react";

const generateSignupURL = (
  language: string,
  audid: string | undefined,
  platform: string | undefined,
  sessionId: string,
  accessToken: string | undefined,
  params?: Record<string, string | undefined>,
) => {
  const uri = new URL(`https://www.blacknut.com/${language.split("-")[0]}/offers`);
  uri.searchParams.append("sid", sessionId);
  uri.searchParams.append("env", getEnv(platform));
  uri.searchParams.append("device", apiService.userAgent.deviceType.toLowerCase());
  apiService.userAgent.brand &&
    uri.searchParams.append("brand", apiService.userAgent.brand.toLowerCase());
  apiService.userAgent.model &&
    uri.searchParams.append("model", apiService.userAgent.model.toLowerCase());
  audid && uri.searchParams.append("audid", audid);
  accessToken && uri.searchParams.append("token", accessToken);
  uri.searchParams.append("ua", createUserAgentString(apiService.userAgent));
  const brand = apiService.userAgent.brand;
  if (!params?.source) {
    if (brand === "Samsung" && apiService.userAgent.deviceType === "TV") {
      // Do't ask me why
      uri.searchParams.append("source", "samsungTV");
    } else if (brand) {
      uri.searchParams.append("source", brand);
    }
  }
  if (params) {
    for (const key of Object.keys(params)) {
      const val = params[key];
      if (val) {
        uri.searchParams.append(key, val);
      }
    }
  }
  logD(LOGGING_TAG, "Using signup url: %o", uri.toString());
  return uri;
};
const useSignupURL = (params?: Record<string, string | undefined>) => {
  const { i18n } = useTranslation();
  const { audid, platform, sessionId, userToken } = useSelector(
    (state: State) => state.globalState,
  );
  const uri = useMemo(
    () =>
      generateSignupURL(
        i18n.language,
        audid,
        platform,
        sessionId,
        userToken?.accessToken,
        params,
      ),
    [i18n.language, audid, platform, sessionId, userToken?.accessToken, params],
  );
  return {
    uri,
  };
};

export { useSignupURL };
